import React from 'react';
import ToggleCardsButton from './ToggleCardsButton';

const CardsHeader = ({ children, disabled, onClick }) => (
  <div className="aridhia-cards-header sticky-panel-header">
    {onClick && (<ToggleCardsButton disabled={disabled} onClick={onClick} />)}
    <div className="flex justify-end">
      {children}
    </div>
  </div>
);

export default CardsHeader;
